<footer id="footer" role="contentinfo">
  <div class="footer-container">
    @for (item of footerItems; track $index) {
      <div aria-label="Company Information" class="link-container">
        <span class="footer-title footer-text">{{ item.title }}</span>
          @for (label of item.labels; track $index) {
            @if (label.link) {
              <a class="footer-link footer-text" id="links" target="_blank" [href]="label.to">
                {{ label.label }}
              </a>
            } @else {
              @if (label.label === "") {
                <span class="footer-link footer-text">&nbsp;</span>
              } @else {
                <span class="footer-link footer-text" id="text">{{ label.label }}</span>
              }
            }
          }
      </div>
    }
  </div>
  <div class="copyright-container">
    <span aria-label="Copyright Notice" class="footer-title footer-text">© {{ currentYear }} K12 NCSEAA</span>
  </div>
</footer>